import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { EventNovaLogo } from './Branding';
import { FiGrid, FiClock, FiUsers, FiBriefcase, FiPieChart, FiSettings, FiLogOut, FiPlayCircle, FiInfo } from 'react-icons/fi';

const navItems = [
  { id: 'overview', icon: FiInfo, label: 'Overview' },
  { id: 'dashboard', icon: FiGrid, label: 'Command' },
  { id: 'demo', icon: FiPlayCircle, label: 'How It Works' },
  { id: 'timeline', icon: FiClock, label: 'Timeline' },
  { id: 'guests', icon: FiUsers, label: 'Guests' },
  { id: 'vendors', icon: FiBriefcase, label: 'Vendors' },
  { id: 'budget', icon: FiPieChart, label: 'Budget' },
  { id: 'settings', icon: FiSettings, label: 'Settings' },
];

export default function Sidebar({ activeTab, setActiveTab }) {
  return (
    <aside className="w-20 md:w-64 h-full glass-panel border-l-0 border-y-0 rounded-none border-r flex flex-col justify-between hidden sm:flex shrink-0 z-50 relative">
      <div className="overflow-y-auto no-scrollbar">
        <div className="p-6">
          <EventNovaLogo size="md" className="hidden md:flex" />
          <div className="md:hidden flex justify-center">
            <EventNovaLogo size="sm" />
          </div>
        </div>

        <nav className="mt-4 px-3 space-y-1">
          {navItems.map((item) => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 relative group ${
                  isActive ? 'text-white' : 'text-[#94A3B8] hover:text-white hover:bg-white/5'
                }`}
              >
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 bg-gradient-to-r from-[rgba(157,78,221,0.2)] to-transparent rounded-xl border-l-[3px] border-[#9D4EDD]"
                    initial={false}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  />
                )}
                <SafeIcon icon={item.icon} className={`text-xl relative z-10 ${isActive ? 'text-[#E5C158]' : ''}`} />
                <span className={`font-bold hidden md:block relative z-10 text-xs lg:text-sm tracking-tight ${isActive ? 'text-glow-purple' : ''}`}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>

      <div className="p-4 border-t border-white/5 bg-[#050508]/50">
         <div className="hidden md:flex items-center gap-3 mb-4 px-2">
           <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9D4EDD] to-indigo-600 border border-white/20 flex items-center justify-center text-[10px] font-bold text-white">LL</div>
           <div className="flex-1 overflow-hidden">
             <div className="text-xs font-bold text-white truncate">LingLink Admin</div>
             <div className="text-[10px] text-[#94A3B8]">Pro Terminal</div>
           </div>
         </div>
         <button className="w-full flex items-center justify-center md:justify-start gap-4 px-4 py-3 rounded-xl text-[#94A3B8] hover:text-white hover:bg-red-500/10 transition-colors group">
            <SafeIcon icon={FiLogOut} className="text-xl group-hover:text-red-400" />
            <span className="hidden md:block font-bold text-sm">Exit Studio</span>
         </button>
      </div>
    </aside>
  );
}